import { patientPrescriptionsClient } from '@/api/patients/patientPrescriptionsClient';
import { QueryKey } from '@/data/query';

interface PatientPrescriptionsPageParams {
  size: number;
  after?: string;
  before?: string;
}

const queryClient = patientPrescriptionsClient();

export const useGetPatientPrescriptions = (
  pageParams: PatientPrescriptionsPageParams,
  search: string,
  patientId: number,
) => {
  const queryResult = queryClient?.listPatientPrescriptions?.useQuery({
    queryKey: [QueryKey.GetPatientPrescriptions, pageParams, search, patientId],
    queryData: {
      params: { id: Number(patientId) },
      query: { page: pageParams, search },
    },
    enabled: Boolean(patientId),
    refetchOnMount: true,
  });

  return {
    data: queryResult.data?.body ?? null,
    isLoading: queryResult.isLoading,
    isSuccess: queryResult.isSuccess,
    isError: queryResult.isError,
    refetch: queryResult.refetch,
  };
};
